var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "item" },
    [
      _c(
        "div",
        { staticClass: "header", style: { marginTop: "20px" } },
        [
          _c("w-fa", {
            staticClass: "event-ico",
            class: _vm.event.ComputedProps.icon,
            attrs: { icon: _vm.event.ComputedProps.icon },
          }),
          _vm._v(_vm._s(_vm.event.ComputedProps.title) + " "),
        ],
        1
      ),
      _c("div", { staticClass: "header info" }, [
        _c("div", { staticClass: "user" }, [
          _vm._v(" " + _vm._s(_vm.event.Creator) + " "),
        ]),
        _c("div", { staticClass: "time" }, [
          _vm._v(" " + _vm._s(_vm.event.getTimeStampString()) + " "),
        ]),
      ]),
      _vm.event.ComputedProps.message
        ? _c("div", {
            directives: [
              {
                name: "safe-html",
                rawName: "v-safe-html",
                value: _vm.event.ComputedProps.message,
                expression: "event.ComputedProps.message",
              },
            ],
            staticClass: "message",
          })
        : _vm._e(),
      _c(
        "w-list",
        { staticClass: "message" },
        _vm._l(_vm.event.AWSDocuments, function (doc) {
          return _c(
            "w-list-item",
            { key: doc.ID },
            [
              _c(
                "w-list-item-icon",
                [_c("w-fa", { attrs: { icon: ["far", "file"] } })],
                1
              ),
              _c("w-list-item-text", [_vm._v(_vm._s(doc.getName()))]),
              _c(
                "w-list-item-action",
                [
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("common.preview"),
                          expression: "$ct('common.preview')",
                        },
                      ],
                      attrs: { disabled: !doc.canPreview() },
                      on: {
                        click: function ($event) {
                          return _vm.preview(doc)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "eye" } })],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-list-item-action",
                [
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("common.download"),
                          expression: "$ct('common.download')",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.download(doc)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "download" } })],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-list-item-action",
                [
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("common.delete"),
                          expression: "$ct('common.delete')",
                        },
                      ],
                      staticClass: "danger",
                      on: {
                        click: function ($event) {
                          return _vm.remove(doc)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "trash" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }